import React from "react";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import DtPicker from "../../Misc/DtPicker";
import SVGDock from "../../Misc/SvgIcons/SVGDock";
import SVGSteering1 from "../../Misc/SvgIcons/SVGSteering1";
import TrackerSummaryAdd from "./TrackerSummaryAdd";
import TrackerSummaryList from "./TrackerSummaryList";

export default class TrackerItem extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
      list: [],
      cistern: {},
      showModal: false,
      modalItem: {},
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.load();
    }
  }
  onMethodFinish = () => {
    this.load();
    if (this.props.onMethodFinish) {
      this.props.onMethodFinish();
    }
  };
  onChange = (id, value) => {
    this.setState(
      (state) => {
        let { item } = state;
        item[id] = value;
        return { item };
      },
      () => this.save()
    );
  };
  save = async () => {
    this.setState({ pending: true });
    const { item } = this.state;
    let result = await this.context.api.q(`/tracker/set`, {
      id: this.props.itemId,
      datestart: item.datestart,
      datestop: item.datestop,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      this.load();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };
  load = async () => {
    if (this.props.itemId) {
      this.setState({ pending: true });

      let item = await this.context.api.q(`/tracker/get`, {
        id: this.props.itemId,
      });

      let list = await this.context.api.qa("/summary/list", {
        filter: {
          tracker: this.props.itemId,
        },
      });

      let cistern = await this.context.api.qo("/cistern/list", {
        filter: { ship: item.ship },
      });

      this.setState({ pending: false, item, list, cistern });
    } else {
      this.setState({ pending: false, item: {}, list: [], cistern: {} });
    }
  };

  onModalClose = () => {
    this.setState({ showModal: false });
  };
  onModalOpen = (modalItem) => {
    this.setState({ showModal: true, modalItem });
  };
  onEditFinish = () => {
    this.load();
  };
  render() {
    const { item, list, cistern, pending, showModal, modalItem } = this.state;
    if (!item.id)
      return (
        <Blocker spinnerFixed hAuto on={pending}>
          <DefaultNotFound />
        </Blocker>
      );

    const iconColor = item.typecode === "cruise.tracker" ? "primary" : "info";

    return (
      <>
        <TrackerSummaryAdd
          show={showModal}
          item={modalItem}
          cistern={cistern}
          tracker={item}
          onClose={this.onModalClose}
          onFinish={this.onEditFinish}
          key={modalItem.id}
        />
        <Blocker spinnerFixed hAuto on={pending}>
          <div className="p-4 bg-light mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center">
                <div className="mr-3">{item.label}</div>
                <div className="mr-3 text-muted ">{item.shipname}</div>
                <div className="mr-3 text-dark-75 ">
                  {item.departurename}{" "}
                  {item.arrivalname !== item.departurename && (
                    <>- {item.arrivalname}</>
                  )}
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center justify-content-end text-right">
                  <EssenceStateLabel
                    stateCode={item.statetypecode}
                    stateLabel={item.statelabel}
                    essence="tracker"
                    id={item.id}
                  />
                  <EssenceActionsDropdown
                    essence={"tracker"}
                    key={item.id}
                    id={item.id}
                    label={item.label}
                    onFinish={this.onMethodFinish}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center  ">
              <div className="mr-3 text-dark-50 d-flex ">
                {item.datestart && (
                  <>
                    <span className="text-muted mr-2">Начало: </span>
                    <DtPicker
                      onChange={(v) => this.onChange("datestart", v)}
                      value={item.datestart}
                      time
                      inline
                    />
                  </>
                )}
                {item.datestop && (
                  <>
                    <span className="text-muted ml-3 mr-2">Окончание: </span>
                    <DtPicker
                      onChange={(v) => this.onChange("datestop", v)}
                      value={item.datestop}
                      time
                      inline
                    />
                  </>
                )}
              </div>
              <div className="flex-grow-0">
                <div
                  className="text-primary cursor-pointer small"
                  onClick={() => this.onModalOpen({})}
                >
                  <i className="fa fa-plus mr-2"></i>Добавить отчет
                </div>
              </div>
            </div>
          </div>
          <TrackerSummaryList
            list={list}
            tracker={item}
            onFinish={this.onEditFinish}
            onEdit={this.onModalOpen}
            cistern={cistern}
          />
        </Blocker>
      </>
    );
  }
}
